import { getFontFamilies, getSkinParams } from '@wix/thunderbolt-becky-root'
import { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import _ from 'lodash'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { FeatureRefs } from '../../cssFeatures.types'
// import { fontStylable } from '@wix/stylable-santa-flatten/cjs'

const getSTCSS = (styleItem: Style): string =>
	styleItem.style?.properties?.['$st-css'] || styleItem.style?.properties?.['st-css'] || ''

const getFontsFromStyle = (style: Style): Array<string> => {
	const stylableStCss = getSTCSS(style)
	if (stylableStCss) {
		// return fontStylable.findFontsInCss(stylableStCss, () => true, false)
		return EMPTY_ARRAY
	}

	const skinParams = getSkinParams(style.skin)
	return _.flatMap(style.style?.properties, (styleProperty, styleParam) => {
		if (skinParams?.types[styleParam] === 'FONT') {
			return getFontFamilies(styleProperty)
		}
		if (styleParam === 'fontFamily' || skinParams?.types[styleParam] === 'FONT_FAMILY') {
			return styleProperty.split(',')
		}
		return EMPTY_ARRAY
	})
}

export const styleFontFamilies = {
	predicate: () => true,
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => refs.compStyles(component),
		toViewItem: (__, compStyles) => {
			if (!compStyles) {
				return EMPTY_ARRAY
			}
			if (compStyles.type === 'classic') {
				return Object.values(compStyles.css).flatMap(getFontsFromStyle)
			}
			return Object.values(compStyles.css).flatMap((variants) =>
				Object.values(variants).flatMap(getFontsFromStyle)
			)
		},
	}),
}
